import React from 'react';
import { useSelector } from 'react-redux';

import { useFetchWalletDetailQuery } from 'modules/company/wallet/hooks';
import { getAccount } from 'modules/company/wallet/redux/selector';
import { type AppState } from 'src/core/reducers';

import { HomepageWallet } from './HomepageWallet';
import { HomepageWalletPlaceholder } from '../HomepageWalletPlaceholder';

type Props = {
  company: {
    id: string;
    country: string;
    currency: string;
    is_kyb_validated: boolean;
  };
  isAccountLoaded: boolean;
  isLoading: boolean;
  isMarqeta: boolean;
  hasPendingAchSource: boolean;
  hasPendingGpaOrders: boolean;
  hasValidatedAchSource: boolean;
};

export const HomepageWalletContainer = ({
  company,
  isAccountLoaded,
  isLoading,
  isMarqeta,
  hasPendingAchSource,
  hasPendingGpaOrders,
  hasValidatedAchSource,
}: Props) => {
  const { id: companyId } = company;

  const account = useSelector((state: AppState) => getAccount(state));
  const fetchWalletDetailQueryState = useFetchWalletDetailQuery(companyId);

  if (isLoading || fetchWalletDetailQueryState.status !== 'success') {
    return <HomepageWalletPlaceholder />;
  }
  const { walletSummary, hasMissingFunds } = fetchWalletDetailQueryState.data;

  if (!walletSummary) {
    return null;
  }

  return (
    <HomepageWallet
      account={account}
      company={company}
      hasMissingFunds={hasMissingFunds}
      isAccountLoaded={isAccountLoaded}
      isMarqeta={isMarqeta}
      hasPendingGpaOrders={hasPendingGpaOrders}
      mustConnectBankAccount={hasPendingAchSource || !hasValidatedAchSource}
      walletSummary={walletSummary}
    />
  );
};
